<template>
  <svg :width="width" :height="height" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 13.0625C16.0128 13.0625 16.4355 13.4485 16.4933 13.9459L16.5 14.0625V17.2167L19.1992 17.9399C19.7327 18.0829 20.0492 18.6312 19.9063 19.1647C19.7736 19.66 19.2913 19.9684 18.7959 19.8955L18.6816 19.8718L15.3008 18.9659C14.8247 18.8384 14.5213 18.3879 14.5632 17.9132C14.5354 17.839 14.5162 17.7605 14.5067 17.6791L14.5 17.5625V14.0625C14.5 13.5102 14.9477 13.0625 15.5 13.0625Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5 10C11.0817 10 7.5 13.5817 7.5 18C7.5 22.4183 11.0817 26 15.5 26C19.9183 26 23.5 22.4183 23.5 18C23.5 13.5817 19.9183 10 15.5 10ZM15.5 12C18.8137 12 21.5 14.6863 21.5 18C21.5 21.3137 18.8137 24 15.5 24C12.1863 24 9.5 21.3137 9.5 18C9.5 14.6863 12.1863 12 15.5 12Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5 0H7.5V2H23.5V0H25.5V2H28.5C29.6046 2 30.5 2.89543 30.5 4V28C30.5 29.1046 29.6046 30 28.5 30H2.5C1.39543 30 0.5 29.1046 0.5 28V4C0.5 2.89543 1.39543 2 2.5 2H5.5V0ZM2.5 4V6H28.5V4H2.5ZM2.5 28V8H28.5V28H2.5Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CalendarIconPartTime',
  props: {
    width: {
      type: Number,
      default: 30,
    },
    height: {
      type: Number,
      default: 30,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
